import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../components/Button';
import ModalContainer from '../../../../components/ModalContainer';

const RevokeModal = ({
  isOpenRevokeModal,
  setIsOpenRevokeModal,
  onClickModalRevokeBtn,
}) => {
  const { t } = useTranslation();

  return (
    <ModalContainer
      modalWidthType="modal-500px"
      openModal={isOpenRevokeModal}
      closeModal={() => setIsOpenRevokeModal(false)}
    >
      <div className="header">
        {/* Revoke API key */}
        <div className="title">{t('33b92b21e9')}</div>
      </div>
      <div className="body">
        <div>{t('93d554f98e')}</div>
      </div>
      <div className="footer non-border-top-footer">
        {/* Cancel */}
        <Button
          label={t('ea4788705e')}
          className="btn-cancel"
          onClick={() => setIsOpenRevokeModal(false)}
        />
        {/* Revoke */}
        <Button
          label={t('64c2406bee')}
          className="btn-delete"
          onClick={() => onClickModalRevokeBtn()}
        />
      </div>
    </ModalContainer>
  );
};

export default React.memo(RevokeModal);
